import { Link } from "react-router-dom";
import { ArrowLeft, FileText, AlertTriangle } from "lucide-react";
import {
  TERMS_SECTIONS, PILOT_WARNING, TERMS_CURRENT_VERSION, TERMS_VERSION_DATE, LEGAL_AUDIENCE,
} from "@/config/legalText";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900 mb-6"
              data-testid="terms-back-link">
          <ArrowLeft className="w-4 h-4" /> Volver al inicio
        </Link>

        <div className="flex items-center gap-3 mb-2">
          <FileText className="w-6 h-6 text-[#1E3A5F]" />
          <h1 className="text-3xl font-heading font-extrabold text-slate-900" data-testid="terms-title">
            Términos y Condiciones de Uso
          </h1>
        </div>
        <div className="text-sm text-slate-500 mb-6">
          Versión {TERMS_CURRENT_VERSION} — Piloto · Publicada el {TERMS_VERSION_DATE}
        </div>

        <div className="rounded-xl border border-[#FCD34D] bg-[#FEF3C7] text-[#92400E] p-4 mb-8 flex items-start gap-3"
             data-testid="terms-pilot-callout">
          <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" />
          <div className="text-sm">
            <b>Aviso importante — Versión piloto.</b> {PILOT_WARNING}
          </div>
        </div>

        <p className="text-sm text-slate-600 mb-8">Aplica a: {LEGAL_AUDIENCE}</p>

        <div className="space-y-8">
          {TERMS_SECTIONS.map((s) => (
            <section key={s.id} id={s.id} data-testid={`terms-section-${s.id}`}>
              <h2 className="text-lg font-heading font-bold text-slate-900 mb-2">{s.title}</h2>
              <div className="text-sm text-slate-700 whitespace-pre-line leading-relaxed">{s.body}</div>
            </section>
          ))}
        </div>

        <div className="mt-10 text-xs text-slate-500 border-t border-slate-200 pt-6">
          También revisa el{" "}
          <Link to="/aviso-privacidad" className="text-[#1E3A5F] underline" data-testid="terms-link-privacy">
            Aviso de Privacidad
          </Link>.
        </div>

        <div className="mt-6 text-xs text-slate-400 text-center">
          © 2026 broker-mexico.com — Términos {TERMS_CURRENT_VERSION}
        </div>
      </div>
    </div>
  );
}
